export default {"src":"__ASTRO_ASSET_IMAGE__CdChH8Dg__","width":256,"height":256,"format":"webp"}